export const medicalStandard = {
  'kidney': {
    '钾': [3.5, 5.3],
    '钠': [136, 146],
    '氯': [96, 108],
    '总蛋白': [60, 87],
    '白蛋白': [35, 55],
    '球蛋白': [20, 35],
    '白球比例': [1, 2.5],
    '总胆红素': [3.4, 23.3],
    '直接胆红素': [0, 6.8],
    '间接胆红素': [3.4, 17.08],
    '丙氨酸氨基转移酶（谷丙转氨酶）': [9, 40],
    '天冬氨酸氨基转移酶（谷草转氨酶）': [15, 40],
    ' AST:ALT': [0.8, 1.5],
    '总胆汁酸': [0.5, 10],
    '谷氨酰转移酶': [7, 50],
    '碱性磷酸酶': [40, 150],
    '胆碱酯酶': [4000, 12600],
    '尿素氮': [3.1, 8],
    '肌酐': [35, 97],
    '尿酸': [208, 428],
    '钙': [2.1, 2.6],
    '磷': [0.7, 1.6],
    '镁': [0.7, 1.1],
    '估算的肾小球滤过率': [90, 130],
    '总胆固醇': [3.1, 5.2],
    '甘油三酯': [0.4, 1.7],
    '高密度脂蛋白胆固醇': [1.16, 1.42],
    '低密度脂蛋白胆固醇': [0, 4.14],
    '葡萄糖': [3.9, 6.1],
    '超敏c反应蛋白': [0.0, 3.0],
    '总二氧化碳': [21.0, 31.0],
    '血清胱抑素c': [0, 1.03],
    'β2微球蛋白': [1, 3],
    '补体c1q': [159.0, 233.0],
    '阴离子隙': [10, 22],
    '乳酸测定': [0.5, 2.5],
    '尿素氮/肌酐': [38, 188],
    '胆碱酯酶.1': [5000, 12000],
    '载脂蛋白A': [1.07, 2.05],
    '载脂蛋白B': [0.52, 1.38],
    '同型半胱氨酸': [0, 15],
    '小而密低密度脂蛋白胆固醇': [0.243, 1.393],
    '前白蛋白': [200, 400],
    '乳酸脱氢酶': [120.0, 250.0],
    'α-羟丁酸脱氢酶': [72.0, 182.0],
    '肌酸激酶': [38.0, 174.0],
    '肌酸激酶-MB': [0.0, 25.0],
    '糖化血红蛋白': [4, 6]
  },
  'blood': {
    '白细胞数': [4.0, 9.2],
    '红细胞数': [4.3, 5.74],
    '血红蛋白测定': [131, 172],
    '红细胞比积': [38.0, 50.8],
    '红细胞压积': [0.4, 0.5],
    '平均红细胞体积': [82.6, 99.1],
    '平均红细胞血红蛋白含量': [27.0, 33.8],
    '平均红细胞血红蛋白浓度': [320, 354],
    '血小板': [125, 320],
    '红细胞体积分布宽度CV': [11.5, 14.5],
    '红细胞体积分布宽度SD': [37.0, 54.0],
    '血小板比积': [0.17, 0.35],
    '淋巴细胞比值': [20.0, 40.0],
    '淋巴细胞绝对值': [1.1, 3.2],
    '中性粒细胞百分数': [50.0, 70.0],
    '嗜酸性粒细胞百分数': [0.5, 5.0],
    '嗜碱性粒细胞百分数': [0.0, 1.0],
    '单核细胞比值': [3.0, 10.0],
    '单核细胞绝对值': [0.12, 0.6],
    '平均血小板体积': [9.4, 12.5],
    '血小板体积分布宽度': [9.0, 17.0],
    '血小板大细胞率': [13.0, 43.0],
    '中性粒细胞数': [2.0, 6.3],
    '嗜酸性粒细胞数': [0.02, 0.5],
    '嗜碱性粒细胞数': [0.0, 0.06]
  },
  'urine': {
    '尿红细胞数': [0.0, 25.0],
    '红细胞高倍视野': [0.0, 4.5],
    '尿白细胞数': [0.0, 30.0],
    '白细胞高倍视野': [0.0, 5.4],
    '尿上皮细胞数': [0.0, 15.0],
    '上皮细胞高倍视野': [0.0, 3.8],
    '尿管型数': [0.0, 1.3],
    '管型低倍视野': [0.0, 3.8],
    '尿细菌数': [0.0, 1200.0],
    '尿胆红素': [0.0, 0.2],
    '细菌高倍视野': [0.0, 12.0],
    '病理管型': [0.0, 0.5],
    '小圆上皮细胞': [0.0, 3.0],
    '电导率': [5.0, 38.0],
    '浊度': [0, 0],
    '尿比重': [1.015, 1.025],
    '尿ph': [5.5, 6.5],
    '尿白细胞': [0.0, 25.0],
    '亚硝酸盐': [0.0, 0.0],
    '尿蛋白': [0, 30],
    '葡萄糖': [0.0, 50.0],
    '尿酮体': [0, 0],
    '尿胆原': [0, 2],
    '尿潜血': [0, 0.06],
    '尿流式沉渣检查': [0.0, 0.0],
    '尿干化学检查': [0.0, 0.0],
    '颜色': [1, 1],
    '镜检': [0.0, 0.0]
  },
  'protein': {
    '（晨尿/随机尿）蛋白定量': [0.0, 100.0],
    '（24h）蛋白定量': [0.0, 100.0],
    '24h尿蛋白': [28.0, 141.0],
    '（晨尿/随机尿）肌酐': [8800.0, 17600.0],
    '（24h）肌酐': [8800.0, 17600.0],
    '尿总蛋白/肌酐': [0.0, 200.0],
    '尿微量蛋白/肌酐比': [0.0, 30.0],
    '微量白蛋白': [0.0, 30.0],
    '24h尿量': [1000.0, 2000.0],
    '24h尿肌酐定量': [8.4, 17.2],
    '视黄醇结合蛋白': [0.0, 0.7],
    '尿N-乙酰-β-D-氨基葡萄糖苷酶': [0.7, 11.2],
    'NAG与Cr比值': [1.0, 6.3],
    '尿酸': [1500.0, 4500.0]
  },
  'weight': {
    '高压': [90.0, 140.0], '低压': [60.0, 90.0], '脉搏': [60.0, 100.0]
  },
  'ultrasonic': {
    '左肾长': [11.0, 13.5],
    '左肾宽': [5.0, 7.0],
    '左肾皮质厚': [0.5, 1.5],
    '右肾长': [10.8, 13.0],
    '右肾宽': [5.0, 7.0],
    '右肾皮质厚': [0.5, 1.5]
  },
  'immune': {
    '总补体': [23.0, 62.0],
    '免疫球蛋白G': [6.94, 16.18],
    '免疫球蛋白A': [0.7, 3.8],
    '免疫球蛋白M': [0.6, 2.63],
    '免疫球蛋白E': [0.0, 100.0],
    '补体C3': [0.85, 2.0],
    '补体C4': [0.12, 0.4],
    '辅助/诱导性T淋巴细胞绝对计数': [404.0, 1612.0],
    '抑制/细胞毒性T淋巴细胞绝对计数': [220.0, 1129.0],
    'B淋巴细胞绝对计数': [80.0, 616.0],
    '自然杀伤性淋巴细胞绝对计数': [84.0, 724.0],
    'T淋巴细胞': [50.0, 82.0],
    '辅助/诱导性T淋巴细胞': [24.0, 54.0],
    '抑制/细胞毒性T淋巴细胞': [14.0, 41.0],
    'CD4/CD8比值': [0.7, 3.1],
    'B淋巴细胞': [5.0, 21.0],
    '自然杀伤性淋巴细胞': [6.0, 38.0],
    'T淋巴细胞绝对计数': [723.0, 2737.0],
    '抗链球菌溶血素O': [0.0, 125.0],
    '类风湿因子': [0, 20],
    'C反应蛋白': [0.0, 0.8],
    '25-羟维生素D': [20.0, 50.0],
    'N端-B型钠尿肽前体': [300, 450],
    '全血肌钙蛋白I测定': [0.01, 0.023],
    '肌酸激酶同工酶': [2, 7.2],
    '肌红蛋白': [23.0, 112.0]
  }
}

export const specialMedical = {
  'kidney': [
    '氯',
    '总蛋白',
    '白蛋白',
    '钙',
    '高密度脂蛋白胆固醇'
  ],
  'blood': [
    '平均红细胞体积',
    '平均红细胞血红蛋白浓度',
    '红细胞体积分布宽度SD',
    '中性粒细胞百分数',
    '中性粒细胞数'
  ],
  'urine': [
    '尿红细胞数',
    '红细胞高倍视野',
    '尿白细胞数',
    '白细胞高倍视野',
    '尿管型数',
    '管型低倍视野',
    '尿细菌数',
    '小圆上皮细胞',
    '完整非溶血红细胞绝对值',
    '完整非溶血红细胞百分比',
    '电导率',
    '尿蛋白'
  ],
  'protein': [
    '（24h）蛋白定量',
    '24h尿蛋白',
    '（24h）肌酐',
    '尿总蛋白/肌酐',
    '尿微量蛋白/肌酐比'
  ]
}

export const specialData = {
  'kidney': [
    {
      'date': '2013-02-21 00:00:00',
      '钾': '4.5',
      '钠': '140.1',
      '氯': '103.7',
      '总蛋白': '71.9',
      '白蛋白': '41.9',
      '球蛋白': '30.0',
      '白球比例': '1.4',
      '总胆红素': '19.4',
      '直接胆红素': '3.0',
      '间接胆红素': '16.4',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '12.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '19.0',
      ' AST:ALT': '0.93',
      '总胆汁酸': '5.4',
      '谷氨酰转移酶': '14.0',
      '碱性磷酸酶': '46.0',
      '胆碱酯酶': '5498.9',
      '尿素氮': '4.6',
      '肌酐': '79.0',
      '尿酸': '344.0',
      '钙': '2.33',
      '磷': '1.21',
      '镁': '0.91',
      '估算的肾小球滤过率': '93.0',
      '总胆固醇': '3.31',
      '甘油三酯': '0.53',
      '高密度脂蛋白胆固醇': '1.35',
      '低密度脂蛋白胆固醇': '1.87',
      '葡萄糖': '4.62',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '27.6',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.5',
      '补体c1q': '105.0',
      '阴离子隙': '13.3',
      '乳酸测定': '0.87',
      '尿素氮/肌酐': '58.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2013-08-12 00:00:00',
      '钾': '4.2',
      '钠': '137.3',
      '氯': '104.5',
      '总蛋白': '67.2',
      '白蛋白': '39.5',
      '球蛋白': '27.7',
      '白球比例': '1.4',
      '总胆红素': '11.0',
      '直接胆红素': '4.8',
      '间接胆红素': '6.2',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '20.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '19.0',
      ' AST:ALT': '0.93',
      '总胆汁酸': '5.4',
      '谷氨酰转移酶': '14.0',
      '碱性磷酸酶': '46.0',
      '胆碱酯酶': '5498.9',
      '尿素氮': '4.69',
      '肌酐': '80.0',
      '尿酸': '421.0',
      '钙': '2.3',
      '磷': '1.34',
      '镁': '0.86',
      '估算的肾小球滤过率': '93.0',
      '总胆固醇': '3.37',
      '甘油三酯': '0.61',
      '高密度脂蛋白胆固醇': '1.35',
      '低密度脂蛋白胆固醇': '1.87',
      '葡萄糖': '4.95',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '26.5',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.5',
      '补体c1q': '105.0',
      '阴离子隙': '10.5',
      '乳酸测定': '0.87',
      '尿素氮/肌酐': '58.6',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2014-02-19 00:00:00',
      '钾': '4.0',
      '钠': '139.8',
      '氯': '104.3',
      '总蛋白': '72.6',
      '白蛋白': '45.2',
      '球蛋白': '27.4',
      '白球比例': '1.6',
      '总胆红素': '17.1',
      '直接胆红素': '7.4',
      '间接胆红素': '9.7',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '19.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '19.0',
      ' AST:ALT': '0.93',
      '总胆汁酸': '4.4',
      '谷氨酰转移酶': '13.0',
      '碱性磷酸酶': '41.0',
      '胆碱酯酶': '5498.9',
      '尿素氮': '4.63',
      '肌酐': '87.0',
      '尿酸': '289.0',
      '钙': '2.42',
      '磷': '1.32',
      '镁': '0.94',
      '估算的肾小球滤过率': '93.0',
      '总胆固醇': '3.21',
      '甘油三酯': '0.47',
      '高密度脂蛋白胆固醇': '1.22',
      '低密度脂蛋白胆固醇': '1.87',
      '葡萄糖': '4.83',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '27.7',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.5',
      '补体c1q': '105.0',
      '阴离子隙': '11.8',
      '乳酸测定': '2.5',
      '尿素氮/肌酐': '53.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2015-08-30 00:00:00',
      '钾': '4.55',
      '钠': '140.0',
      '氯': '104.6',
      '总蛋白': '73.4',
      '白蛋白': '47.1',
      '球蛋白': '26.3',
      '白球比例': '1.8',
      '总胆红素': '20.9',
      '直接胆红素': '7.1',
      '间接胆红素': '13.8',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '12.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '14.0',
      ' AST:ALT': '0.93',
      '总胆汁酸': '1.7',
      '谷氨酰转移酶': '12.0',
      '碱性磷酸酶': '43.0',
      '胆碱酯酶': '5498.9',
      '尿素氮': '5.08',
      '肌酐': '92.0',
      '尿酸': '363.0',
      '钙': '2.38',
      '磷': '1.3',
      '镁': '0.89',
      '估算的肾小球滤过率': '93.0',
      '总胆固醇': '3.63',
      '甘油三酯': '0.63',
      '高密度脂蛋白胆固醇': '1.1775',
      '低密度脂蛋白胆固醇': '1.87',
      '葡萄糖': '5.05',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '28.4',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.5',
      '补体c1q': '105.0',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2018-10-17 00:00:00',
      '钾': '4.64',
      '钠': '137.9',
      '氯': '99.9',
      '总蛋白': '69.4',
      '白蛋白': '43.5',
      '球蛋白': '25.9',
      '白球比例': '1.68',
      '总胆红素': '33.9',
      '直接胆红素': '5.5',
      '间接胆红素': '28.4',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '18.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '17.0',
      ' AST:ALT': '0.93',
      '总胆汁酸': '2.1',
      '谷氨酰转移酶': '13.0',
      '碱性磷酸酶': '44.0',
      '胆碱酯酶': '5498.9',
      '尿素氮': '6.35',
      '肌酐': '99.0',
      '尿酸': '372.0',
      '钙': '2.39',
      '磷': '1.16',
      '镁': '0.9',
      '估算的肾小球滤过率': '93.0',
      '总胆固醇': '3.4433333333333334',
      '甘油三酯': '0.62',
      '高密度脂蛋白胆固醇': '1.135',
      '低密度脂蛋白胆固醇': '1.87',
      '葡萄糖': '4.52',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '26.299999999999997',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.5',
      '补体c1q': '105.0',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2018-10-23 00:00:00',
      '钾': '4.05',
      '钠': '139.0',
      '氯': '106.0',
      '总蛋白': '73.25',
      '白蛋白': '44.45',
      '球蛋白': '28.95',
      '白球比例': '1.6466666666666667',
      '总胆红素': '23.049999999999997',
      '直接胆红素': '3.6',
      '间接胆红素': '19.45',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '15.5',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '17.5',
      ' AST:ALT': '0.9750000000000001',
      '总胆汁酸': '2.0',
      '谷氨酰转移酶': '12.25',
      '碱性磷酸酶': '43.5',
      '胆碱酯酶': '5594.549999999999',
      '尿素氮': '4.8',
      '肌酐': '98.0',
      '尿酸': '371.0',
      '钙': '2.31',
      '磷': '1.37',
      '镁': '0.8875',
      '估算的肾小球滤过率': '93.0',
      '总胆固醇': '3.2566666666666664',
      '甘油三酯': '0.61',
      '高密度脂蛋白胆固醇': '1.0925',
      '低密度脂蛋白胆固醇': '1.87',
      '葡萄糖': '4.56',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '24.2',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.56',
      '补体c1q': '105.0',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2020-01-16 00:00:00',
      '钾': '4.55',
      '钠': '140.0',
      '氯': '106.0',
      '总蛋白': '77.1',
      '白蛋白': '45.4',
      '球蛋白': '32.0',
      '白球比例': '1.6133333333333333',
      '总胆红素': '12.2',
      '直接胆红素': '1.7',
      '间接胆红素': '10.5',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '13.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '18.0',
      ' AST:ALT': '1.02',
      '总胆汁酸': '1.9',
      '谷氨酰转移酶': '11.5',
      '碱性磷酸酶': '43.0',
      '胆碱酯酶': '5690.2',
      '尿素氮': '3.4',
      '肌酐': '99.0',
      '尿酸': '419.0',
      '钙': '2.3',
      '磷': '0.99',
      '镁': '0.875',
      '估算的肾小球滤过率': '91.0',
      '总胆固醇': '3.07',
      '甘油三酯': '0.6',
      '高密度脂蛋白胆固醇': '1.05',
      '低密度脂蛋白胆固醇': '1.87',
      '葡萄糖': '4.6',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '22.3',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.62',
      '补体c1q': '106.16666666666667',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2020-06-10 00:00:00',
      '钾': '4.2',
      '钠': '136.0',
      '氯': '100.0',
      '总蛋白': '75.3',
      '白蛋白': '45.9',
      '球蛋白': '29.0',
      '白球比例': '1.58',
      '总胆红素': '23.3',
      '直接胆红素': '2.1',
      '间接胆红素': '21.2',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '14.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '16.0',
      ' AST:ALT': '1.0650000000000002',
      '总胆汁酸': '1.8',
      '谷氨酰转移酶': '10.75',
      '碱性磷酸酶': '42.5',
      '胆碱酯酶': '5785.85',
      '尿素氮': '5.2',
      '肌酐': '103.0',
      '尿酸': '416.0',
      '钙': '2.29',
      '磷': '1.31',
      '镁': '0.8625',
      '估算的肾小球滤过率': '87.0',
      '总胆固醇': '3.73',
      '甘油三酯': '0.78',
      '高密度脂蛋白胆固醇': '1.37',
      '低密度脂蛋白胆固醇': '2.11',
      '葡萄糖': '4.8',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '25.3',
      '血清胱抑素c': '0.85',
      'β2微球蛋白': '1.6800000000000002',
      '补体c1q': '107.33333333333333',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2020-07-06 00:00:00',
      '钾': '3.87',
      '钠': '139.6',
      '氯': '103.2',
      '总蛋白': '71.2',
      '白蛋白': '44.5',
      '球蛋白': '26.7',
      '白球比例': '1.67',
      '总胆红素': '15.8',
      '直接胆红素': '1.9',
      '间接胆红素': '13.9',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '19.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '21.0',
      ' AST:ALT': '1.11',
      '总胆汁酸': '1.7',
      '谷氨酰转移酶': '10.0',
      '碱性磷酸酶': '42.0',
      '胆碱酯酶': '5881.5',
      '尿素氮': '4.13',
      '肌酐': '103.0',
      '尿酸': '377.0',
      '钙': '2.14',
      '磷': '1.3',
      '镁': '0.85',
      '估算的肾小球滤过率': '86.5',
      '总胆固醇': '3.455',
      '甘油三酯': '0.8400000000000001',
      '高密度脂蛋白胆固醇': '1.3',
      '低密度脂蛋白胆固醇': '1.9049999999999998',
      '葡萄糖': '4.0',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '24.700000000000003',
      '血清胱抑素c': '0.8200000000000001',
      'β2微球蛋白': '1.74',
      '补体c1q': '108.5',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2020-08-24 00:00:00',
      '钾': '3.87',
      '钠': '140.0',
      '氯': '105.0',
      '总蛋白': '72.3',
      '白蛋白': '42.9',
      '球蛋白': '39.0',
      '白球比例': '1.595',
      '总胆红素': '32.4',
      '直接胆红素': '2.6',
      '间接胆红素': '17.2',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '21.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '21.0',
      ' AST:ALT': '1.01',
      '总胆汁酸': '2.0',
      '谷氨酰转移酶': '12.5',
      '碱性磷酸酶': '46.0',
      '胆碱酯酶': '6056.55',
      '尿素氮': '3.8',
      '肌酐': '104.0',
      '尿酸': '471.0',
      '钙': '2.19',
      '磷': '1.16',
      '镁': '0.875',
      '估算的肾小球滤过率': '86.0',
      '总胆固醇': '3.18',
      '甘油三酯': '0.9',
      '高密度脂蛋白胆固醇': '1.23',
      '低密度脂蛋白胆固醇': '1.7',
      '葡萄糖': '3.2',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '24.1',
      '血清胱抑素c': '0.79',
      'β2微球蛋白': '1.8',
      '补体c1q': '109.66666666666667',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2020-11-06 00:00:00',
      '钾': '4.36',
      '钠': '142.3',
      '氯': '105.7',
      '总蛋白': '74.7',
      '白蛋白': '45.0',
      '球蛋白': '29.7',
      '白球比例': '1.52',
      '总胆红素': '27.5',
      '直接胆红素': '7.0',
      '间接胆红素': '20.5',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '23.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '21.0',
      ' AST:ALT': '0.91',
      '总胆汁酸': '2.3',
      '谷氨酰转移酶': '15.0',
      '碱性磷酸酶': '50.0',
      '胆碱酯酶': '6231.6',
      '尿素氮': '3.7',
      '肌酐': '92.0',
      '尿酸': '354.0',
      '钙': '2.2',
      '磷': '1.11',
      '镁': '0.8999999999999999',
      '估算的肾小球滤过率': '90.0',
      '总胆固醇': '3.57',
      '甘油三酯': '0.64',
      '高密度脂蛋白胆固醇': '1.33',
      '低密度脂蛋白胆固醇': '1.37',
      '葡萄糖': '4.56',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '23.8',
      '血清胱抑素c': '0.9500000000000001',
      'β2微球蛋白': '1.655',
      '补体c1q': '110.83333333333333',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2021-04-15 00:00:00',
      '钾': '3.92',
      '钠': '138.0',
      '氯': '104.0',
      '总蛋白': '75.3',
      '白蛋白': '44.9',
      '球蛋白': '30.0',
      '白球比例': '1.56',
      '总胆红素': '21.7',
      '直接胆红素': '2.7',
      '间接胆红素': '20.8',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '19.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '21.0',
      ' AST:ALT': '0.845',
      '总胆汁酸': '1.8499999999999999',
      '谷氨酰转移酶': '15.0',
      '碱性磷酸酶': '46.5',
      '胆碱酯酶': '6254.75',
      '尿素氮': '4.1',
      '肌酐': '96.0',
      '尿酸': '346.0',
      '钙': '2.28',
      '磷': '1.07',
      '镁': '0.9249999999999999',
      '估算的肾小球滤过率': '94.0',
      '总胆固醇': '3.4',
      '甘油三酯': '0.96',
      '高密度脂蛋白胆固醇': '1.32',
      '低密度脂蛋白胆固醇': '1.85',
      '葡萄糖': '4.6',
      '超敏c反应蛋白': '0.05',
      '总二氧化碳': '23.5',
      '血清胱抑素c': '1.11',
      'β2微球蛋白': '1.51',
      '补体c1q': '112.0',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '170.0',
      'α-羟丁酸脱氢酶': '101.0',
      '肌酸激酶': '96.0',
      '肌酸激酶-MB': '12.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2021-06-25 00:00:00',
      '钾': '4.24',
      '钠': '140.6',
      '氯': '105.1',
      '总蛋白': '76.7',
      '白蛋白': '47.2',
      '球蛋白': '29.5',
      '白球比例': '1.6',
      '总胆红素': '30.4',
      '直接胆红素': '9.3',
      '间接胆红素': '21.1',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '27.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '21.0',
      ' AST:ALT': '0.78',
      '总胆汁酸': '1.4',
      '谷氨酰转移酶': '15.0',
      '碱性磷酸酶': '43.0',
      '胆碱酯酶': '6277.9',
      '尿素氮': '4.82',
      '肌酐': '98.0',
      '尿酸': '393.0',
      '钙': '2.2',
      '磷': '1.02',
      '镁': '0.95',
      '估算的肾小球滤过率': '92.0',
      '总胆固醇': '3.65',
      '甘油三酯': '0.915',
      '高密度脂蛋白胆固醇': '1.35',
      '低密度脂蛋白胆固醇': '1.95',
      '葡萄糖': '4.85',
      '超敏c反应蛋白': '0.06333333333333334',
      '总二氧化碳': '24.35',
      '血清胱抑素c': '0.76',
      'β2微球蛋白': '1.5699999999999998',
      '补体c1q': '119.0',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '154.5',
      'α-羟丁酸脱氢酶': '100.5',
      '肌酸激酶': '142.5',
      '肌酸激酶-MB': '10.5',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2021-10-29 00:00:00',
      '钾': '3.97',
      '钠': '138.0',
      '氯': '103.0',
      '总蛋白': '76.7',
      '白蛋白': '47.0',
      '球蛋白': '30.0',
      '白球比例': '1.6',
      '总胆红素': '29.1',
      '直接胆红素': '5.9',
      '间接胆红素': '3.4',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '19.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '21.0',
      ' AST:ALT': '0.78',
      '总胆汁酸': '1.4',
      '谷氨酰转移酶': '15.0',
      '碱性磷酸酶': '43.0',
      '胆碱酯酶': '6277.9',
      '尿素氮': '4.2',
      '肌酐': '99.0',
      '尿酸': '365.0',
      '钙': '2.32',
      '磷': '1.05',
      '镁': '0.95',
      '估算的肾小球滤过率': '90.0',
      '总胆固醇': '3.9',
      '甘油三酯': '0.87',
      '高密度脂蛋白胆固醇': '1.38',
      '低密度脂蛋白胆固醇': '2.05',
      '葡萄糖': '5.1',
      '超敏c反应蛋白': '0.07666666666666666',
      '总二氧化碳': '25.2',
      '血清胱抑素c': '0.9',
      'β2微球蛋白': '1.63',
      '补体c1q': '126.0',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '139.0',
      'α-羟丁酸脱氢酶': '100.0',
      '肌酸激酶': '189.0',
      '肌酸激酶-MB': '9.0',
      '糖化血红蛋白': '5.3'
    },
    {
      'date': '2022-06-02 00:00:00',
      '钾': '4.21',
      '钠': '138.0',
      '氯': '105.0',
      '总蛋白': '75.6',
      '白蛋白': '46.4',
      '球蛋白': '29.0',
      '白球比例': '1.6',
      '总胆红素': '22.9',
      '直接胆红素': '2.5',
      '间接胆红素': '3.4',
      '丙氨酸氨基转移酶（谷丙转氨酶）': '10.0',
      '天冬氨酸氨基转移酶（谷草转氨酶）': '18.0',
      ' AST:ALT': '0.78',
      '总胆汁酸': '1.4',
      '谷氨酰转移酶': '15.0',
      '碱性磷酸酶': '43.0',
      '胆碱酯酶': '6277.9',
      '尿素氮': '3.7',
      '肌酐': '110.0',
      '尿酸': '373.0',
      '钙': '2.48',
      '磷': '1.13',
      '镁': '0.95',
      '估算的肾小球滤过率': '79.0',
      '总胆固醇': '3.55',
      '甘油三酯': '0.58',
      '高密度脂蛋白胆固醇': '1.29',
      '低密度脂蛋白胆固醇': '1.8',
      '葡萄糖': '5.1',
      '超敏c反应蛋白': '0.09',
      '总二氧化碳': '23.0',
      '血清胱抑素c': '0.63',
      'β2微球蛋白': '1.63',
      '补体c1q': '126.0',
      '阴离子隙': '11.6',
      '乳酸测定': '1.29',
      '尿素氮/肌酐': '55.2',
      '胆碱酯酶.1': '5619.0',
      '载脂蛋白A': '1.18',
      '载脂蛋白B': '0.54',
      '同型半胱氨酸': '11.4',
      '小而密低密度脂蛋白胆固醇': '0.464',
      '前白蛋白': '304.6',
      '乳酸脱氢酶': '139.0',
      'α-羟丁酸脱氢酶': '100.0',
      '肌酸激酶': '189.0',
      '肌酸激酶-MB': '9.0',
      '糖化血红蛋白': '5.3'
    }
  ],
  'blood': [
    {
      'date': '2018-10-17 00:00:00',
      '白细胞数': '6.04',
      '红细胞数': '5.03',
      '血红蛋白测定': '157.0',
      '红细胞比积': '46.2',
      '红细胞压积': '0.48',
      '平均红细胞体积': '91.8',
      '平均红细胞血红蛋白含量': '31.2',
      '平均红细胞血红蛋白浓度': '340',
      '血小板': '239.0',
      '红细胞体积分布宽度CV': '12.0',
      '红细胞体积分布宽度SD': '39.4',
      '血小板比积': '0.23',
      '淋巴细胞比值': '41.9',
      '淋巴细胞绝对值': '2.5',
      '中性粒细胞百分数': '44.2',
      '嗜酸性粒细胞百分数': '6.1',
      '嗜碱性粒细胞百分数': '1.0',
      '单核细胞比值': '6.8',
      '单核细胞绝对值': '0.41',
      '平均血小板体积': '9.7',
      '血小板体积分布宽度': '10.6',
      '血小板大细胞率': '21.6',
      '中性粒细胞数': '2.7',
      '嗜酸性粒细胞数': '0.37',
      '嗜碱性粒细胞数': '0.06'
    },
    {
      'date': '2019-10-24 00:00:00',
      '白细胞数': '7.59',
      '红细胞数': '5.5',
      '血红蛋白测定': '173.0',
      '红细胞比积': '51.9',
      '红细胞压积': '0.48',
      '平均红细胞体积': '94.4',
      '平均红细胞血红蛋白含量': '31.5',
      '平均红细胞血红蛋白浓度': '333',
      '血小板': '216.0',
      '红细胞体积分布宽度CV': '12.2',
      '红细胞体积分布宽度SD': '41.5',
      '血小板比积': '0.21',
      '淋巴细胞比值': '31.1',
      '淋巴细胞绝对值': '2.4',
      '中性粒细胞百分数': '58.4',
      '嗜酸性粒细胞百分数': '3.4',
      '嗜碱性粒细胞百分数': '0.4',
      '单核细胞比值': '5.9',
      '单核细胞绝对值': '0.51',
      '平均血小板体积': '9.9',
      '血小板体积分布宽度': '10.6',
      '血小板大细胞率': '23.6',
      '中性粒细胞数': '4.4',
      '嗜酸性粒细胞数': '0.26',
      '嗜碱性粒细胞数': '0.03'
    },
    {
      'date': '2020-01-16 00:00:00',
      '白细胞数': '7.37',
      '红细胞数': '4.96',
      '血红蛋白测定': '155.0',
      '红细胞比积': '49.8',
      '红细胞压积': '0.48',
      '平均红细胞体积': '97.0',
      '平均红细胞血红蛋白含量': '31.3',
      '平均红细胞血红蛋白浓度': '322',
      '血小板': '275.0',
      '红细胞体积分布宽度CV': '11.5',
      '红细胞体积分布宽度SD': '41.2',
      '血小板比积': '0.26',
      '淋巴细胞比值': '49.7',
      '淋巴细胞绝对值': '3.66',
      '中性粒细胞百分数': '42.5',
      '嗜酸性粒细胞百分数': '2.3',
      '嗜碱性粒细胞百分数': '0.5',
      '单核细胞比值': '5.0',
      '单核细胞绝对值': '0.37',
      '平均血小板体积': '9.4',
      '血小板体积分布宽度': '10.3',
      '血小板大细胞率': '20.1',
      '中性粒细胞数': '3.13',
      '嗜酸性粒细胞数': '0.17',
      '嗜碱性粒细胞数': '0.04'
    },
    {
      'date': '2020-06-10 00:00:00',
      '白细胞数': '5.39',
      '红细胞数': '5.17',
      '血红蛋白测定': '167.0',
      '红细胞比积': '47.7',
      '红细胞压积': '0.48',
      '平均红细胞体积': '93.4',
      '平均红细胞血红蛋白含量': '32.3',
      '平均红细胞血红蛋白浓度': '346',
      '血小板': '239.0',
      '红细胞体积分布宽度CV': '11.3',
      '红细胞体积分布宽度SD': '39.0',
      '血小板比积': '0.22',
      '淋巴细胞比值': '43.0',
      '淋巴细胞绝对值': '2.32',
      '中性粒细胞百分数': '43.6',
      '嗜酸性粒细胞百分数': '6.5',
      '嗜碱性粒细胞百分数': '0.6',
      '单核细胞比值': '6.3',
      '单核细胞绝对值': '0.34',
      '平均血小板体积': '9.2',
      '血小板体积分布宽度': '10.1',
      '血小板大细胞率': '18.8',
      '中性粒细胞数': '2.35',
      '嗜酸性粒细胞数': '0.35',
      '嗜碱性粒细胞数': '0.03'
    },
    {
      'date': '2020-07-06 00:00:00',
      '白细胞数': '5.69',
      '红细胞数': '5.07',
      '血红蛋白测定': '161.0',
      '红细胞比积': '45.6',
      '红细胞压积': '0.4766666666666666',
      '平均红细胞体积': '89.9',
      '平均红细胞血红蛋白含量': '31.8',
      '平均红细胞血红蛋白浓度': '353',
      '血小板': '251.0',
      '红细胞体积分布宽度CV': '11.9',
      '红细胞体积分布宽度SD': '38.0',
      '血小板比积': '0.24',
      '淋巴细胞比值': '48.2',
      '淋巴细胞绝对值': '2.7',
      '中性粒细胞百分数': '37.5',
      '嗜酸性粒细胞百分数': '7.0',
      '嗜碱性粒细胞百分数': '0.4',
      '单核细胞比值': '6.9',
      '单核细胞绝对值': '0.39',
      '平均血小板体积': '9.7',
      '血小板体积分布宽度': '10.6',
      '血小板大细胞率': '22.1',
      '中性粒细胞数': '2.1',
      '嗜酸性粒细胞数': '0.4',
      '嗜碱性粒细胞数': '0.02'
    },
    {
      'date': '2020-11-03 00:00:00',
      '白细胞数': '7.31',
      '红细胞数': '5.32',
      '血红蛋白测定': '168.0',
      '红细胞比积': '51.0',
      '红细胞压积': '0.47333333333333333',
      '平均红细胞体积': '95.9',
      '平均红细胞血红蛋白含量': '31.6',
      '平均红细胞血红蛋白浓度': '329',
      '血小板': '194.0',
      '红细胞体积分布宽度CV': '12.2',
      '红细胞体积分布宽度SD': '41.8',
      '血小板比积': '0.21',
      '淋巴细胞比值': '40.6',
      '淋巴细胞绝对值': '3.0',
      '中性粒细胞百分数': '45.9',
      '嗜酸性粒细胞百分数': '4.1',
      '嗜碱性粒细胞百分数': '0.4',
      '单核细胞比值': '9.0',
      '单核细胞绝对值': '0.66',
      '平均血小板体积': '10.8',
      '血小板体积分布宽度': '12.7',
      '血小板大细胞率': '31.0',
      '中性粒细胞数': '3.4',
      '嗜酸性粒细胞数': '0.3',
      '嗜碱性粒细胞数': '0.03'
    },
    {
      'date': '2021-04-15 00:00:00',
      '白细胞数': '4.74',
      '红细胞数': '4.79',
      '血红蛋白测定': '159.0',
      '红细胞比积': '51.0',
      '红细胞压积': '0.47',
      '平均红细胞体积': '97.7',
      '平均红细胞血红蛋白含量': '33.2',
      '平均红细胞血红蛋白浓度': '340',
      '血小板': '226.0',
      '红细胞体积分布宽度CV': '11.8',
      '红细胞体积分布宽度SD': '42.4',
      '血小板比积': '0.22',
      '淋巴细胞比值': '39.0',
      '淋巴细胞绝对值': '1.85',
      '中性粒细胞百分数': '49.4',
      '嗜酸性粒细胞百分数': '3.15',
      '嗜碱性粒细胞百分数': '0.6',
      '单核细胞比值': '7.4',
      '单核细胞绝对值': '0.35',
      '平均血小板体积': '9.5',
      '血小板体积分布宽度': '10.2',
      '血小板大细胞率': '20.8',
      '中性粒细胞数': '2.34',
      '嗜酸性粒细胞数': '0.17',
      '嗜碱性粒细胞数': '0.03'
    },
    {
      'date': '2021-10-29 00:00:00',
      '白细胞数': '4.52',
      '红细胞数': '4.96',
      '血红蛋白测定': '161.0',
      '红细胞比积': '51.0',
      '红细胞压积': '0.48',
      '平均红细胞体积': '96.8',
      '平均红细胞血红蛋白含量': '32.5',
      '平均红细胞血红蛋白浓度': '335',
      '血小板': '248.0',
      '红细胞体积分布宽度CV': '11.9',
      '红细胞体积分布宽度SD': '42.5',
      '血小板比积': '0.25',
      '淋巴细胞比值': '47.6',
      '淋巴细胞绝对值': '2.15',
      '中性粒细胞百分数': '42.6',
      '嗜酸性粒细胞百分数': '2.2',
      '嗜碱性粒细胞百分数': '0.8',
      '单核细胞比值': '6.9',
      '单核细胞绝对值': '0.31',
      '平均血小板体积': '10.2',
      '血小板体积分布宽度': '11.8',
      '血小板大细胞率': '26.3',
      '中性粒细胞数': '1.93',
      '嗜酸性粒细胞数': '0.20500000000000002',
      '嗜碱性粒细胞数': '0.03'
    },
    {
      'date': '2022-06-02 00:00:00',
      '白细胞数': '4.93',
      '红细胞数': '4.89',
      '血红蛋白测定': '157.0',
      '红细胞比积': '51.0',
      '红细胞压积': '0.47',
      '平均红细胞体积': '95.3',
      '平均红细胞血红蛋白含量': '32.1',
      '平均红细胞血红蛋白浓度': '337',
      '血小板': '247.0',
      '红细胞体积分布宽度CV': '11.5',
      '红细胞体积分布宽度SD': '40.0',
      '血小板比积': '0.24',
      '淋巴细胞比值': '51.1',
      '淋巴细胞绝对值': '2.52',
      '中性粒细胞百分数': '37.7',
      '嗜酸性粒细胞百分数': '4.9',
      '嗜碱性粒细胞百分数': '1.0',
      '单核细胞比值': '5.3',
      '单核细胞绝对值': '0.26',
      '平均血小板体积': '9.8',
      '血小板体积分布宽度': '11.0',
      '血小板大细胞率': '23.6',
      '中性粒细胞数': '1.86',
      '嗜酸性粒细胞数': '0.24',
      '嗜碱性粒细胞数': '0.05'
    }
  ],
  'urine': [
    {
      'date': '2016-03-15 00:00:00',
      '尿红细胞数': '3.0',
      '红细胞高倍视野': '0.4',
      '尿白细胞数': '3.0',
      '白细胞高倍视野': '0.9',
      '尿上皮细胞数': '1.0',
      '上皮细胞高倍视野': '0.1',
      '尿管型数': '0.4',
      '管型低倍视野': '0.1',
      '尿细菌数': '7.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.7',
      '病理管型': '0.3',
      '小圆上皮细胞': '0.8',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '2.0',
      '完整非溶血红细胞百分比': '60.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '26.0',
      '浊度': '0.0',
      '尿比重': '1.005',
      '尿ph': '6.0',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2018-10-17 00:00:00',
      '尿红细胞数': '3.0',
      '红细胞高倍视野': '0.4',
      '尿白细胞数': '3.0',
      '白细胞高倍视野': '0.9',
      '尿上皮细胞数': '1.0',
      '上皮细胞高倍视野': '0.1',
      '尿管型数': '0.4',
      '管型低倍视野': '0.1',
      '尿细菌数': '7.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.7',
      '病理管型': '0.3',
      '小圆上皮细胞': '0.8',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '2.0',
      '完整非溶血红细胞百分比': '60.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '26.0',
      '浊度': '0.0',
      '尿比重': '1.025',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.3333333333333333',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2018-10-22 00:00:00',
      '尿红细胞数': '3.0',
      '红细胞高倍视野': '0.4',
      '尿白细胞数': '3.0',
      '白细胞高倍视野': '0.9',
      '尿上皮细胞数': '1.0',
      '上皮细胞高倍视野': '0.1',
      '尿管型数': '0.4',
      '管型低倍视野': '0.1',
      '尿细菌数': '7.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.7',
      '病理管型': '0.3',
      '小圆上皮细胞': '0.8',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '2.0',
      '完整非溶血红细胞百分比': '60.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '26.0',
      '浊度': '0.0',
      '尿比重': '1.022',
      '尿ph': '6.0',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '1.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.6666666666666666',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-01-16 00:00:00',
      '尿红细胞数': '2.0',
      '红细胞高倍视野': '0.4',
      '尿白细胞数': '6.0',
      '白细胞高倍视野': '0.9',
      '尿上皮细胞数': '1.0',
      '上皮细胞高倍视野': '0.1',
      '尿管型数': '0.6',
      '管型低倍视野': '0.1',
      '尿细菌数': '31.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.7',
      '病理管型': '0.0',
      '小圆上皮细胞': '1.3',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '1.5',
      '完整非溶血红细胞百分比': '73.3',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.1',
      '粘液丝': '0.0',
      '电导率': '23.7',
      '浊度': '0.0',
      '尿比重': '1.016',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '1.0',
      '尿胆原': '1.0',
      '尿潜血': '1.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '1.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-06-10 00:00:00',
      '尿红细胞数': '1.0',
      '红细胞高倍视野': '0.4',
      '尿白细胞数': '3.0',
      '白细胞高倍视野': '0.9',
      '尿上皮细胞数': '1.0',
      '上皮细胞高倍视野': '0.1',
      '尿管型数': '1.0',
      '管型低倍视野': '0.1',
      '尿细菌数': '17.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.7',
      '病理管型': '0.4',
      '小圆上皮细胞': '1.2',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '0.6',
      '完整非溶血红细胞百分比': '71.4',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '7.0',
      '浊度': '0.0',
      '尿比重': '1.005',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '1.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-07-06 00:00:00',
      '尿红细胞数': '1.7',
      '红细胞高倍视野': '0.4',
      '尿白细胞数': '4.0',
      '白细胞高倍视野': '0.9',
      '尿上皮细胞数': '0.8',
      '上皮细胞高倍视野': '0.1',
      '尿管型数': '0.56',
      '管型低倍视野': '0.1',
      '尿细菌数': '45.55',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.7',
      '病理管型': '0.2',
      '小圆上皮细胞': '0.85',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '1.1',
      '完整非溶血红细胞百分比': '69.9',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '10.25',
      '浊度': '0.0',
      '尿比重': '1.025',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-07-10 00:00:00',
      '尿红细胞数': '2.4',
      '红细胞高倍视野': '0.4',
      '尿白细胞数': '5.0',
      '白细胞高倍视野': '0.9',
      '尿上皮细胞数': '0.6',
      '上皮细胞高倍视野': '0.1',
      '尿管型数': '0.12',
      '管型低倍视野': '0.1',
      '尿细菌数': '74.1',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.7',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.5',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '1.6',
      '完整非溶血红细胞百分比': '68.4',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '13.5',
      '浊度': '0.0',
      '尿比重': '1.014',
      '尿ph': '6.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-07-31 00:00:00',
      '尿红细胞数': '4.1',
      '红细胞高倍视野': '0.7',
      '尿白细胞数': '13.9',
      '白细胞高倍视野': '2.5',
      '尿上皮细胞数': '3.0',
      '上皮细胞高倍视野': '0.5',
      '尿管型数': '0.25',
      '管型低倍视野': '0.73',
      '尿细菌数': '140.1',
      '尿胆红素': '0.0',
      '细菌高倍视野': '1.4',
      '病理管型': '0.0',
      '小圆上皮细胞': '3.0',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '3.2',
      '完整非溶血红细胞百分比': '78.1',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '13.6',
      '浊度': '0.0',
      '尿比重': '1.019',
      '尿ph': '6.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '10.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-08-24 00:00:00',
      '尿红细胞数': '5.0',
      '红细胞高倍视野': '0.6',
      '尿白细胞数': '1.0',
      '白细胞高倍视野': '1.5',
      '尿上皮细胞数': '0.0',
      '上皮细胞高倍视野': '0.5',
      '尿管型数': '0.0',
      '管型低倍视野': '0.54',
      '尿细菌数': '55.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '1.15',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.1',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '4.8',
      '完整非溶血红细胞百分比': '100.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.1',
      '粘液丝': '0.255',
      '电导率': '8.7',
      '浊度': '0.0',
      '尿比重': '1.0',
      '尿ph': '7.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '1.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-09-22 00:00:00',
      '尿红细胞数': '3.0',
      '红细胞高倍视野': '0.5',
      '尿白细胞数': '2.7',
      '白细胞高倍视野': '0.5',
      '尿上皮细胞数': '1.2',
      '上皮细胞高倍视野': '0.2',
      '尿管型数': '0.12',
      '管型低倍视野': '0.35',
      '尿细菌数': '90.4',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.9',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.7',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '2.7',
      '完整非溶血红细胞百分比': '87.5',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.51',
      '电导率': '22.8',
      '浊度': '0.0',
      '尿比重': '1.02',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.25',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-10-28 00:00:00',
      '尿红细胞数': '2.8',
      '红细胞高倍视野': '0.5',
      '尿白细胞数': '4.3',
      '白细胞高倍视野': '0.8',
      '尿上皮细胞数': '2.7',
      '上皮细胞高倍视野': '0.5',
      '尿管型数': '0.38',
      '管型低倍视野': '1.1',
      '尿细菌数': '171.6',
      '尿胆红素': '0.0',
      '细菌高倍视野': '1.7',
      '病理管型': '0.0',
      '小圆上皮细胞': '2.5',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '2.7',
      '完整非溶血红细胞百分比': '95.4',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.77',
      '电导率': '19.8',
      '浊度': '0.0',
      '尿比重': '1.019',
      '尿ph': '6.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.5',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2020-11-05 00:00:00',
      '尿红细胞数': '0.5',
      '红细胞高倍视野': '0.1',
      '尿白细胞数': '1.6',
      '白细胞高倍视野': '0.3',
      '尿上皮细胞数': '0.2',
      '上皮细胞高倍视野': '0.0',
      '尿管型数': '0.12',
      '管型低倍视野': '0.35',
      '尿细菌数': '154.3',
      '尿胆红素': '0.0',
      '细菌高倍视野': '1.5',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.1',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '0.2',
      '完整非溶血红细胞百分比': '50.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.12',
      '电导率': '21.8',
      '浊度': '0.0',
      '尿比重': '1.022',
      '尿ph': '6.0',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.75',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2021-04-15 00:00:00',
      '尿红细胞数': '1.0',
      '红细胞高倍视野': '0.14',
      '尿白细胞数': '1.0',
      '白细胞高倍视野': '0.275',
      '尿上皮细胞数': '0.0',
      '上皮细胞高倍视野': '0.125',
      '尿管型数': '0.0',
      '管型低倍视野': '0.175',
      '尿细菌数': '2.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.755',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.4',
      '类酵母样菌': '0.2',
      '完整非溶血红细胞绝对值': '0.6',
      '完整非溶血红细胞百分比': '100.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.06',
      '电导率': '13.7',
      '浊度': '0.0',
      '尿比重': '1.011',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '1.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2021-04-22 00:00:00',
      '尿红细胞数': '1.0',
      '红细胞高倍视野': '0.18',
      '尿白细胞数': '1.4',
      '白细胞高倍视野': '0.25',
      '尿上皮细胞数': '1.4',
      '上皮细胞高倍视野': '0.25',
      '尿管型数': '0.0',
      '管型低倍视野': '0.0',
      '尿细菌数': '1.1',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.01',
      '病理管型': '0.0',
      '小圆上皮细胞': '1.3',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '1.0',
      '完整非溶血红细胞百分比': '100.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '16.0',
      '浊度': '0.0',
      '尿比重': '1.021',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '1.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2021-10-29 00:00:00',
      '尿红细胞数': '1.0',
      '红细胞高倍视野': '0.18',
      '尿白细胞数': '3.0',
      '白细胞高倍视野': '0.29500000000000004',
      '尿上皮细胞数': '1.0',
      '上皮细胞高倍视野': '0.14500000000000002',
      '尿管型数': '0.0',
      '管型低倍视野': '0.0',
      '尿细菌数': '0.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.01',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.8',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '0.9',
      '完整非溶血红细胞百分比': '100.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '24.8',
      '浊度': '0.0',
      '尿比重': '1.023',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '10.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '1.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '1.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2021-11-05 00:00:00',
      '尿红细胞数': '1.0',
      '红细胞高倍视野': '0.18',
      '尿白细胞数': '1.9',
      '白细胞高倍视野': '0.34',
      '尿上皮细胞数': '0.2',
      '上皮细胞高倍视野': '0.04',
      '尿管型数': '0.0',
      '管型低倍视野': '0.0',
      '尿细菌数': '3.4',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.01',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.2',
      '类酵母样菌': '0.0',
      '完整非溶血红细胞绝对值': '0.8',
      '完整非溶血红细胞百分比': '80.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.0',
      '电导率': '14.6',
      '浊度': '0.0',
      '尿比重': '1.018',
      '尿ph': '5.5',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.6666666666666667',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2021-11-29 00:00:00',
      '尿红细胞数': '1.5',
      '红细胞高倍视野': '0.27',
      '尿白细胞数': '3.2',
      '白细胞高倍视野': '0.58',
      '尿上皮细胞数': '2.0',
      '上皮细胞高倍视野': '0.36',
      '尿管型数': '0.0',
      '管型低倍视野': '0.0',
      '尿细菌数': '2.3',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.01',
      '病理管型': '0.0',
      '小圆上皮细胞': '2.0',
      '类酵母样菌': '0.1',
      '完整非溶血红细胞绝对值': '1.2',
      '完整非溶血红细胞百分比': '80.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.14',
      '电导率': '22.7',
      '浊度': '0.0',
      '尿比重': '1.027',
      '尿ph': '6.0',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '0.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.33333333333333337',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    },
    {
      'date': '2022-06-02 00:00:00',
      '尿红细胞数': '1.0',
      '红细胞高倍视野': '0.27',
      '尿白细胞数': '1.0',
      '白细胞高倍视野': '0.58',
      '尿上皮细胞数': '0.0',
      '上皮细胞高倍视野': '0.2',
      '尿管型数': '0.0',
      '管型低倍视野': '0.0',
      '尿细菌数': '0.0',
      '尿胆红素': '0.0',
      '细菌高倍视野': '0.01',
      '病理管型': '0.0',
      '小圆上皮细胞': '0.2',
      '类酵母样菌': '0.1',
      '完整非溶血红细胞绝对值': '0.5',
      '完整非溶血红细胞百分比': '100.0',
      '红细胞信息': '0.0',
      '70%红细胞数': '0.0',
      '结晶': '0.0',
      '粘液丝': '0.14',
      '电导率': '11.7',
      '浊度': '0.0',
      '尿比重': '1.012',
      '尿ph': '6.0',
      '尿白细胞': '0.0',
      '亚硝酸盐': '0.0',
      '尿蛋白': '0.0',
      '葡萄糖': '0.0',
      '尿酮体': '0.0',
      '尿胆原': '1.0',
      '尿潜血': '0.0',
      '尿流式沉渣检查': '0.0',
      '尿干化学检查': '0.0',
      '颜色': '0.0',
      '镜检': '0.0',
      '镜检红细胞': '0.5'
    }
  ],
  'protein': [
    {
      'date': '2020-01-16 00:00:00',
      '（晨尿/随机尿）蛋白定量': '128.0',
      '（24h）蛋白定量': '56.0',
      '24h尿蛋白': '70.0',
      '（晨尿/随机尿）肌酐': '20958.0',
      '（24h）肌酐': '10432.0',
      '尿总蛋白/肌酐': '54.0',
      '尿微量蛋白/肌酐比': '4.0',
      '微量白蛋白': '9.5',
      '24h尿量': '1250.0',
      '24h尿肌酐定量': '13.0',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2020-06-10 00:00:00',
      '（晨尿/随机尿）蛋白定量': '114.0',
      '（24h）蛋白定量': '56.0',
      '24h尿蛋白': '70.0',
      '（晨尿/随机尿）肌酐': '8943.0',
      '（24h）肌酐': '10432.0',
      '尿总蛋白/肌酐': '113.0',
      '尿微量蛋白/肌酐比': '4.0',
      '微量白蛋白': '4.0',
      '24h尿量': '1250.0',
      '24h尿肌酐定量': '13.0',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2020-07-06 00:00:00',
      '（晨尿/随机尿）蛋白定量': '88.0',
      '（24h）蛋白定量': '56.0',
      '24h尿蛋白': '70.0',
      '（晨尿/随机尿）肌酐': '18945.0',
      '（24h）肌酐': '10432.0',
      '尿总蛋白/肌酐': '93.0',
      '尿微量蛋白/肌酐比': '4.62',
      '微量白蛋白': '9.9',
      '24h尿量': '1250.0',
      '24h尿肌酐定量': '13.0',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2020-07-31 00:00:00',
      '（晨尿/随机尿）蛋白定量': '62.0',
      '（24h）蛋白定量': '56.0',
      '24h尿蛋白': '62.0',
      '（晨尿/随机尿）肌酐': '12460.5',
      '（24h）肌酐': '10432.0',
      '尿总蛋白/肌酐': '73.0',
      '尿微量蛋白/肌酐比': '2.66',
      '微量白蛋白': '5.2',
      '24h尿量': '1250.0',
      '24h尿肌酐定量': '13.0',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2020-08-24 00:00:00',
      '（晨尿/随机尿）蛋白定量': '36.0',
      '（24h）蛋白定量': '56.0',
      '24h尿蛋白': '70.0',
      '（晨尿/随机尿）肌酐': '5976.0',
      '（24h）肌酐': '10432.0',
      '尿总蛋白/肌酐': '53.0',
      '尿微量蛋白/肌酐比': '0.7',
      '微量白蛋白': '0.5',
      '24h尿量': '1250.0',
      '24h尿肌酐定量': '13.0',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2020-11-05 00:00:00',
      '（晨尿/随机尿）蛋白定量': '33.5',
      '（24h）蛋白定量': '46.0',
      '24h尿蛋白': '35.0',
      '（晨尿/随机尿）肌酐': '22925.0',
      '（24h）肌酐': '9743.0',
      '尿总蛋白/肌酐': '41.5',
      '尿微量蛋白/肌酐比': '5.32',
      '微量白蛋白': '13.8',
      '24h尿量': '2025.0',
      '24h尿肌酐定量': '12.85',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2021-04-15 00:00:00',
      '（晨尿/随机尿）蛋白定量': '31.0',
      '（24h）蛋白定量': '36.0',
      '24h尿蛋白': '101.0',
      '（晨尿/随机尿）肌酐': '4523.0',
      '（24h）肌酐': '9054.0',
      '尿总蛋白/肌酐': '30.0',
      '尿微量蛋白/肌酐比': '3.0',
      '微量白蛋白': '3.1',
      '24h尿量': '2800.0',
      '24h尿肌酐定量': '12.7',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2021-10-29 00:00:00',
      '（晨尿/随机尿）蛋白定量': '145.0',
      '（24h）蛋白定量': '137.0',
      '24h尿蛋白': '323.32',
      '（晨尿/随机尿）肌酐': '30974.0',
      '（24h）肌酐': '5979.0',
      '尿总蛋白/肌酐': '41.0',
      '尿微量蛋白/肌酐比': '3.3',
      '微量白蛋白': '11.4',
      '24h尿量': '2360.0',
      '24h尿肌酐定量': '14.1',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '4501.0',
      '尿尿酸/肌酐': '0.1'
    },
    {
      'date': '2021-11-05 00:00:00',
      '（晨尿/随机尿）蛋白定量': '120.25',
      '（24h）蛋白定量': '137.0',
      '24h尿蛋白': '224.88',
      '（晨尿/随机尿）肌酐': '17449.0',
      '（24h）肌酐': '5979.0',
      '尿总蛋白/肌酐': '45.25',
      '尿微量蛋白/肌酐比': '5.27',
      '微量白蛋白': '10.4',
      '24h尿量': '2360.0',
      '24h尿肌酐定量': '14.1',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '3878.0',
      '尿尿酸/肌酐': '0.14500000000000002'
    },
    {
      'date': '2021-11-29 00:00:00',
      '（晨尿/随机尿）蛋白定量': '95.5',
      '（24h）蛋白定量': '137.0',
      '24h尿蛋白': '126.44',
      '（晨尿/随机尿）肌酐': '20306.0',
      '（24h）肌酐': '5979.0',
      '尿总蛋白/肌酐': '49.5',
      '尿微量蛋白/肌酐比': '5.7',
      '微量白蛋白': '13.1',
      '24h尿量': '2360.0',
      '24h尿肌酐定量': '14.1',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '3255.0',
      '尿尿酸/肌酐': '0.19'
    },
    {
      'date': '2021-12-07 00:00:00',
      '（晨尿/随机尿）蛋白定量': '70.75',
      '（24h）蛋白定量': '137.0',
      '24h尿蛋白': '28.0',
      '（晨尿/随机尿）肌酐': '13683.0',
      '（24h）肌酐': '5979.0',
      '尿总蛋白/肌酐': '53.75',
      '尿微量蛋白/肌酐比': '3.55',
      '微量白蛋白': '7.1',
      '24h尿量': '2360.0',
      '24h尿肌酐定量': '14.1',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '2632.0',
      '尿尿酸/肌酐': '0.23500000000000001'
    },
    {
      'date': '2022-06-02 00:00:00',
      '（晨尿/随机尿）蛋白定量': '46.0',
      '（24h）蛋白定量': '137.0',
      '24h尿蛋白': '28.0',
      '（晨尿/随机尿）肌酐': '7060.0',
      '（24h）肌酐': '5979.0',
      '尿总蛋白/肌酐': '58.0',
      '尿微量蛋白/肌酐比': '1.4',
      '微量白蛋白': '1.1',
      '24h尿量': '2360.0',
      '24h尿肌酐定量': '14.1',
      '视黄醇结合蛋白': '0.1',
      '尿N-乙酰-β-D-氨基葡萄糖苷酶': '3.8',
      'NAG与Cr比值': '3.7',
      '尿酸': '2009.0',
      '尿尿酸/肌酐': '0.28'
    }
  ],
  'weight': [
    {
      'date': '2013-02-21 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '55.0'
    },
    {
      'date': '2013-08-12 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '55.333333333333336'
    },
    {
      'date': '2014-02-19 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '55.666666666666664'
    },
    {
      'date': '2015-08-30 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '56.0'
    },
    {
      'date': '2018-10-17 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '57.5'
    },
    {
      'date': '2018-10-23 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '56.0'
    },
    {
      'date': '2020-01-16 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '58.0'
    },
    {
      'date': '2020-06-10 00:00:00',
      '高压': '105.0',
      '低压': '70.0',
      '脉搏': '60.0',
      '体重': '59.0'
    },
    {
      'date': '2020-07-06 00:00:00',
      '高压': '119.0',
      '低压': '67.0',
      '脉搏': '72.0',
      '体重': '59.0'
    },
    {
      'date': '2020-08-24 00:00:00',
      '高压': '119.0',
      '低压': '73.0',
      '脉搏': '77.0',
      '体重': '59.0'
    },
    {
      'date': '2020-10-28 00:00:00',
      '高压': '117.0',
      '低压': '67.0',
      '脉搏': '81.0',
      '体重': '59.0'
    },
    {
      'date': '2020-11-06 00:00:00',
      '高压': '111.0',
      '低压': '65.0',
      '脉搏': '77.0',
      '体重': '59.0'
    },
    {
      'date': '2020-12-24 00:00:00',
      '高压': '118.0',
      '低压': '71.0',
      '脉搏': '82.0',
      '体重': '59.0'
    },
    {
      'date': '2021-02-26 00:00:00',
      '高压': '121.0',
      '低压': '65.0',
      '脉搏': '70.0',
      '体重': '59.0'
    },
    {
      'date': '2021-04-22 00:00:00',
      '高压': '111.0',
      '低压': '67.5',
      '脉搏': '82.0',
      '体重': '59.0'
    },
    {
      'date': '2021-06-25 00:00:00',
      '高压': '114.0',
      '低压': '63.0',
      '脉搏': '82.0',
      '体重': '59.0'
    },
    {
      'date': '2021-07-19 00:00:00',
      '高压': '119.0',
      '低压': '68.0',
      '脉搏': '70.0',
      '体重': '59.0'
    },
    {
      'date': '2021-09-24 00:00:00',
      '高压': '115.5',
      '低压': '67.5',
      '脉搏': '81.0',
      '体重': '59.0'
    },
    {
      'date': '2021-10-28 00:00:00',
      '高压': '112.0',
      '低压': '77.0',
      '脉搏': '60.0',
      '体重': '59.0'
    },
    {
      'date': '2022-05-26 00:00:00',
      '高压': '111.0',
      '低压': '66.0',
      '脉搏': '75.0',
      '体重': '59.0'
    }
  ],
  'ultrasonic': [
    {
      'date': '2020-01-20 00:00:00',
      '左肾长': '11.4',
      '左肾宽': '4.5',
      '左肾皮质厚': '0.8',
      '右肾长': '10.5',
      '右肾宽': '3.8',
      '右肾皮质厚': '0.7',
      '前列腺横径': '4.4',
      '上下径': '3.4',
      '前后径': '3.6',
      '前列腺体积': '26.2',
      '实质回声': '0'
    },
    {
      'date': '2020-12-17 00:00:00',
      '左肾长': '11.100000000000001',
      '左肾宽': '4.85',
      '左肾皮质厚': '0.8',
      '右肾长': '10.55',
      '右肾宽': '4.0',
      '右肾皮质厚': '0.7',
      '前列腺横径': '4.4',
      '上下径': '3.55',
      '前后径': '3.35',
      '前列腺体积': '26.2',
      '实质回声': '1'
    },
    {
      'date': '2021-04-15 00:00:00',
      '左肾长': '10.8',
      '左肾宽': '5.2',
      '左肾皮质厚': '0.8',
      '右肾长': '10.6',
      '右肾宽': '4.2',
      '右肾皮质厚': '0.7',
      '前列腺横径': '4.4',
      '上下径': '3.7',
      '前后径': '3.1',
      '前列腺体积': '26.2',
      '实质回声': '0'
    },
    {
      'date': '2022-06-02 00:00:00',
      '左肾长': '9.9',
      '左肾宽': '4.2',
      '左肾皮质厚': '0.8',
      '右肾长': '9.4',
      '右肾宽': '3.4',
      '右肾皮质厚': '0.7',
      '前列腺横径': '3.9',
      '上下径': '3.1',
      '前后径': '2.6',
      '前列腺体积': '16.3',
      '实质回声': '0'
    }
  ],
  'immune': [
    {
      'date': '2021-10-29 00:00:00',
      '总补体': '37',
      '免疫球蛋白G': '14.3',
      '免疫球蛋白A': '4.05',
      '免疫球蛋白M': '0.707',
      '免疫球蛋白E': '141',
      '补体C3': '0.652',
      '补体C4': '0.114',
      '辅助/诱导性T淋巴细胞绝对计数': '694.19',
      '抑制/细胞毒性T淋巴细胞绝对计数': '1104.78',
      'B淋巴细胞绝对计数': '150.75',
      '自然杀伤性淋巴细胞绝对计数': '259.14',
      '淋巴细胞绝对数': '2351.6',
      '总淋巴细胞': '98.68',
      'T淋巴细胞': '81.83',
      '辅助/诱导性T淋巴细胞': '29.52',
      '抑制/细胞毒性T淋巴细胞': '46.98',
      'CD4/CD8比值': '0.63',
      'B淋巴细胞': '6.41',
      '自然杀伤性淋巴细胞': '11.02',
      'T淋巴细胞绝对计数': '1924.26',
      '抗链球菌溶血素O': '31.3',
      '类风湿因子': '10.0',
      'C反应蛋白': '0.1',
      '25-羟维生素D': '18.1',
      'N端-B型钠尿肽前体': '35.0',
      '全血肌钙蛋白I测定': '0.005',
      '肌酸激酶同工酶': '1.0',
      '肌红蛋白': '57.0'
    },
    {
      'date': '2022-06-02 00:00:00',
      '总补体': '33',
      '免疫球蛋白G': '14.4',
      '免疫球蛋白A': '3.57',
      '免疫球蛋白M': '0.675',
      '免疫球蛋白E': '105',
      '补体C3': '0.602',
      '补体C4': '0.103',
      '辅助/诱导性T淋巴细胞绝对计数': '840.14',
      '抑制/细胞毒性T淋巴细胞绝对计数': '1191.98',
      'B淋巴细胞绝对计数': '176.71',
      '自然杀伤性淋巴细胞绝对计数': '235.61',
      '淋巴细胞绝对数': '2604.28',
      '总淋巴细胞': '99.29',
      'T淋巴细胞': '83.46',
      '辅助/诱导性T淋巴细胞': '32.26',
      '抑制/细胞毒性T淋巴细胞': '45.77',
      'CD4/CD8比值': '0.7',
      'B淋巴细胞': '6.79',
      '自然杀伤性淋巴细胞': '9.05',
      'T淋巴细胞绝对计数': '2173.55',
      '抗链球菌溶血素O': '31.3',
      '类风湿因子': '10.0',
      'C反应蛋白': '0.1',
      '25-羟维生素D': '31.1',
      'N端-B型钠尿肽前体': '35.0',
      '全血肌钙蛋白I测定': '0.005',
      '肌酸激酶同工酶': '1.0',
      '肌红蛋白': '57.0'
    }
  ]
}
